<div class="flex-column gap-large organization-platform-billing">
    <div class="flex-column gap">
        <div class="font-size-large font-semibold">{{ prefix + 'tabs.profile' | translate }}</div>
        <div class="grid-4col input-grid-gaps">
            <app-select-input [formField]="profileForm.billingPeriod" [staticOptions]="periodOptions" [showClear]="false" [label]="prefix + 'fields.billingPeriod'"></app-select-input>
            <app-tags-input [formField]="profileForm.billingEmails" [submitOnBlur]="true" [label]="prefix + 'fields.billingEmails'"></app-tags-input>
            <app-date-input [formField]="profileForm.billingFrom" [label]="prefix + 'fields.billingFrom'"></app-date-input>
            <app-date-input [formField]="profileForm.billingTo" [showClear]="true" [label]="prefix + 'fields.billingTo'"></app-date-input>
        </div>
        <div class="grid-4col input-grid-gaps">
            <app-select-input [formField]="profileForm.recipientCenterId" [staticOptions]="centerOptions()" [label]="prefix + 'fields.recipientCenter'" (selectionChange)="clearRecipientAddress()"></app-select-input>
            <app-select-input [formField]="profileForm.recipientAddressId" [staticOptions]="recipientAddressOptions()" [label]="prefix + 'fields.recipientAddress'"></app-select-input>
            <app-select-input [formField]="profileForm.destinationCenterId" [staticOptions]="centerOptions()" [label]="prefix + 'fields.destinationCenter'" (selectionChange)="clearDestinationAddress()"></app-select-input>
            <app-select-input [formField]="profileForm.destinationAddressId" [staticOptions]="destinationAddressOptions()" [label]="prefix + 'fields.destinationAddress'"></app-select-input>
        </div>
        <div>{{ prefix + 'fields.addressDefaultsHelp' | translate }}</div>
        <div class="flex gap-large">
            <app-check-input [formField]="profileForm.automaticBasis" [label]="prefix + 'fields.automaticBasis'"></app-check-input>
            <app-check-input [formField]="profileForm.automaticInvoicing" [label]="prefix + 'fields.automaticInvoicing'"></app-check-input>
        </div>
        @if (canUpdate()) {
            <div class="flex justify-content-end"><app-save-button label="organization.updateInfo" [loading]="store.loadingAny()" [disabled]="profileForm().invalid() || store.loadingAny()" (clickEvent)="saveProfile()"></app-save-button></div>
        }
        @if (canCreate() && configurationWarning()) {
            <app-warn-float-message [showSeverityText]="false" [message]="configurationWarning()"></app-warn-float-message>
        }
    </div>

    <div class="flex-column gap">
        <div class="font-size-large font-semibold">{{ prefix + 'tabs.services' | translate }}</div>
        <app-table
            dataKey="id"
            [translatePrefix]="prefix"
            [columns]="contractColumns"
            tableKey="organizationPlatformBillingContracts"
            [gridData]="contractGrid()"
            [refreshCallback]="refreshContracts"
            [defaultSorters]="{ column: 'serviceName', direction: 'ASC' }"
            [hideCheckboxes]="true"
            [showSearch]="true"
            [showCreate]="false"
            [showDetail]="canUpdate()"
            [showDelete]="false"
            (detailCallback)="openContractUpsertDialog($event)"
        >
            <ng-template pTemplate="monthlyUserPrice" let-item="item">
                @if (item.monthlyUserPrice !== null) {
                    {{ item.monthlyUserPrice | formatNumber: 2: true }} Kč
                }
            </ng-template>
            <ng-template pTemplate="fixedServicePrice" let-item="item">
                @if (item.fixedServicePrice !== null) {
                    {{ item.fixedServicePrice | formatNumber: 2: true }} Kč
                }
            </ng-template>
            <ng-template pTemplate="discountPercentage" let-item="item">
                @if (item.discountPercentage !== null) {
                    {{ item.discountPercentage }} %
                }
            </ng-template>
        </app-table>
    </div>

    <div class="flex-column gap">
        <div class="font-size-large font-semibold">{{ prefix + 'tabs.bases' | translate }}</div>
        <ng-template #basisCreateButton>
            @if (canCreate()) {
                <app-button
                    icon="pi-plus"
                    [disabled]="store.loadingAny() || !!basisCreateDisabledReason()"
                    (clickEvent)="openBasisCreateDialog()"
                ></app-button>
            }
        </ng-template>
        <app-table
            dataKey="id"
            [translatePrefix]="prefix"
            [columns]="basisColumns"
            tableKey="organizationPlatformBillingBases"
            [gridData]="basisGrid()"
            [refreshCallback]="refreshBases"
            [defaultSorters]="{ column: 'period', direction: 'DESC' }"
            [buttons]="basisCreateButton"
            [hideCheckboxes]="true"
            [showSearch]="true"
            [showCreate]="false"
            [showDetail]="false"
            [showDelete]="canDelete()"
            (deleteCallbackWithEvent)="deleteBasis($event)"
        >
            <ng-template pTemplate="discountPercentage" let-item="item">{{ item.discountPercentage }} %</ng-template>
            <ng-template pTemplate="actions" let-item="item">
                <div class="flex justify-content-end gap-small">
                    @if (canUpdate() && item.basis.state !== basisStates.CANCELLED) {
                        <app-button [icon]="item.deliveryFailed ? 'pi-refresh' : 'pi-send'" [text]="true" styleClass="tableIcon" [loading]="sendingBasisId() === item.id" [disabled]="sendingBasisId() !== null" [title]="prefix + (item.deliveryFailed ? 'actions.retryDelivery' : 'actions.sendBasis') | translate" (clickEvent)="sendBasis(item.basis)"></app-button>
                    }
                    @if (canCreate() && item.canReplace) {
                        <app-button icon="pi-clone" [text]="true" styleClass="tableIcon" [title]="prefix + 'actions.replaceBasis' | translate" (clickEvent)="openBasisCreateDialog(item.basis)"></app-button>
                    }
                    <app-button icon="pi-file-excel" [text]="true" styleClass="tableIcon" [title]="prefix + 'actions.exportBasis' | translate" (clickEvent)="exportBasis(item.basis)"></app-button>
                </div>
            </ng-template>
        </app-table>
    </div>

    <div class="flex-column gap">
        <div class="font-size-large font-semibold">{{ prefix + 'tabs.invoices' | translate }}</div>
        <ng-template #invoiceCreateButton>
            @if (canCreate()) {
                <app-button
                    icon="pi-plus"
                    [disabled]="store.loadingAny() || !!invoiceCreateDisabledReason()"
                    (clickEvent)="openInvoiceCreateDialog()"
                ></app-button>
            }
        </ng-template>
        <app-table
            dataKey="id"
            [translatePrefix]="prefix"
            [columns]="invoiceColumns"
            tableKey="organizationPlatformBillingInvoices"
            [gridData]="invoiceGrid()"
            [refreshCallback]="refreshInvoices"
            [defaultSorters]="{ column: 'issueDate', direction: 'DESC' }"
            [buttons]="invoiceCreateButton"
            [hideCheckboxes]="true"
            [showSearch]="true"
            [showCreate]="false"
            [showDetail]="false"
            [showDelete]="canDelete()"
            [rowExpansion]="invoiceRows"
            (rowExpanded)="loadInvoiceItems($event)"
            (deleteCallbackWithEvent)="deleteInvoice($event)"
        >
            <ng-template pTemplate="actions" let-item="item">
                <div class="flex justify-content-end gap-small">
                    @if (canUpdate() && item.invoice.state !== invoiceStates.CANCELLED) {
                        <app-button [icon]="item.deliveryFailed ? 'pi-refresh' : 'pi-send'" [text]="true" styleClass="tableIcon" [loading]="sendingInvoiceId() === item.id" [disabled]="sendingInvoiceId() !== null" [title]="prefix + (item.deliveryFailed ? 'actions.retryDelivery' : 'actions.sendInvoice') | translate" (clickEvent)="sendInvoice(item.invoice)"></app-button>
                    }
                    <app-button icon="pi-file-pdf" [text]="true" styleClass="tableIcon" [loading]="exportingInvoice()?.invoiceId === item.id && exportingInvoice()?.format === 'pdf'" [disabled]="exportingInvoice() !== null" [title]="prefix + 'actions.exportPdf' | translate" (clickEvent)="exportInvoice(item.invoice, 'pdf')"></app-button>
                    <app-button icon="pi-file" [text]="true" styleClass="tableIcon" [loading]="exportingInvoice()?.invoiceId === item.id && exportingInvoice()?.format === 'isdoc'" [disabled]="exportingInvoice() !== null" [title]="prefix + 'actions.exportIsdoc' | translate" (clickEvent)="exportInvoice(item.invoice, 'isdoc')"></app-button>
                </div>
            </ng-template>
            <ng-template #invoiceRows let-item="item">
                @if (item.itemsLoading) {
                    <div class="flex justify-content-center p-3"><app-loading></app-loading></div>
                } @else {
                    <app-table
                        dataKey="id"
                        [tableTitle]="prefix + 'invoiceItems'"
                        [translatePrefix]="prefix"
                        [columns]="invoiceItemColumns"
                        [items]="item.items ?? []"
                        [hideCheckboxes]="true"
                        [showSearchBar]="false"
                        [showCreate]="false"
                        [showDetail]="false"
                        [showDelete]="false"
                        [showPagination]="false"
                    >
                    </app-table>
                }
            </ng-template>
        </app-table>
    </div>
</div>
